import { useId, useState } from "react";
import { useDispatch } from "react-redux";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import { USER_ROLES } from "../../../../staticData/userRoles";
import { isUserRole } from "../../../../utils/methods/storeFunc";
import { toggleDuplicateFlow } from "../../../../store/actions/eventDuplicate";

type Props = {
  eventId?: string;
  isDuplicate?: boolean;
  onDuplicateChanged?: () => void;
};

/** Secondary show maintenance actions; the API enforces permissions and blockers. */
export default function ShowOptionsMenu({ eventId, isDuplicate = false, onDuplicateChanged }: Props) {
  const dispatch = useDispatch();
  const menuId = useId();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  if (!eventId || !isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN)) return null;

  return (
    <>
      <Tooltip title="Show options" arrow>
        <IconButton
          size="small"
          aria-label="Show options"
          aria-haspopup="menu"
          aria-controls={anchor ? menuId : undefined}
          aria-expanded={anchor ? true : undefined}
          onClick={(event) => setAnchor(event.currentTarget)}
          sx={{ color: "rgba(255,255,255,0.75)", "&:hover": { color: "#fff" } }}
        >
          <MoreHoriz />
        </IconButton>
      </Tooltip>
      <Menu id={menuId} anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        <MenuItem
          onClick={() => {
            setAnchor(null);
            void toggleDuplicateFlow({ dispatch, eventId, isDuplicate, onDone: onDuplicateChanged });
          }}
        >
          {isDuplicate ? "Unmark Duplicate" : "Mark as Duplicate"}
        </MenuItem>
      </Menu>
    </>
  );
}
